<template>
	<div class="navcon">

		<div class="left">
			<!-- <svg @click="changeIcon()" t="1605835484056" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3298"
			 width="24" height="24">
				<path d="M0 0m57.037419 0l1102.723425 0q57.037419 0 57.037418 57.037419l0 4.943242q0 57.037419-57.037418 57.037419l-1102.723425 0q-57.037419 0-57.037419-57.037419l0-4.943242q0-57.037419 57.037419-57.037419Z"
				 p-id="3299" fill="#8a8a8a"></path>
				<path d="M0 396.790308m57.037419 0l1102.723425 0q57.037419 0 57.037418 57.037419l0 4.943243q0 57.037419-57.037418 57.037418l-1102.723425 0q-57.037419 0-57.037419-57.037418l0-4.943243q0-57.037419 57.037419-57.037419Z"
				 p-id="3300" fill="#8a8a8a"></path>
				<path d="M0 793.580617m57.037419 0l1102.723425 0q57.037419 0 57.037418 57.037418l0 4.943243q0 57.037419-57.037418 57.037419l-1102.723425 0q-57.037419 0-57.037419-57.037419l0-4.943243q0-57.037419 57.037419-57.037418Z"
				 p-id="3301" fill="#8a8a8a"></path>
			</svg> -->
			<!-- <i class="icon" :class="icon?'el-icon-s-fold':'el-icon-s-unfold'" @click="changeIcon"></i> -->
			<img src="../assets/icon/logo.png" alt="" width="45" style="border-radius: 50%;margin-left: 20px;">
			<div>
				<span class="title" style="color:white;font-weight: bold;font-size: 22px;">江苏国际人才公寓</span>
				<sub class="sub" style="font-weight: bold;color: #ff5052;font-size: 14px;"
					@click="gotoPre"><i>V1.0</i></sub>
			</div>
		</div>
		<div class="right" style="">
			<el-menu class="el-menu-demo" mode="horizontal">
				<!-- <notice @isClose="isClose" :title="title" :isShow="isShow"></notice> -->
				<el-menu-item v-if="roleId==12" index="1" class="why" @click="toJZFW">
					<!-- <img style="width:35px;" src="../assets/icon/icon_问号.png" alt=""> -->
					<div class="sumMessage" v-show="jiazhengMessage == 0 ? false : true">{{ jiazhengMessage }}</div>
					<img style="width:23px;margin-bottom: 2px;" src="../assets/icon/jzfw.png" alt="">
				</el-menu-item>
				<el-menu-item v-if="roleId==12" index="2" class="add" @click="toBXGL">
					<!-- <img style="width:35px;" src="../assets/icon/icon_添加.png" alt=""> -->
					<div class="sumMessage" v-show="baoxiuMessage == 0 ? false : true">{{ baoxiuMessage }}</div>
					<img style="width:30px;" src="../assets/icon/bxgl.png" alt="">
				</el-menu-item>
				<el-menu-item index="4" class="add">
					<screenfull id="screenfull">
					</screenfull>
				</el-menu-item>
				<el-menu-item index="3" @click="toAnnounceAndNotice">
					<template slot="title">
						<div class="sumMessage" v-show="sumMessage == 0 ? false : true">{{ sumMessage }}</div>
						<img style="width: 35px;" src="../assets/imgs/铃铛.png" alt="">
					</template>
				</el-menu-item>
				<el-menu-item index="8" @click="openPDF" v-hasPermi="['read:operating:manual']">
					<template slot="title">
						<div title="操作手册">
						<img style="width:35px;" src="../assets/icon/icon_问号.png" alt="">
					</div>
					</template>
				</el-menu-item>

				<!-- <el-submenu index="3"> -->
				<!-- <template slot="title">
						<div class="sumMessage" v-show="sumMessageShow" @click="toAnnounceAndNotice">{{sumMessage}}</div>
						<img style="width: 35px;" src="../assets/imgs/铃铛.png" alt="">
					</template>
					<el-menu-item index="3-1" style="text-align: center;" @click="goNotice(1)">公告
					</el-menu-item>
					<el-menu-item index="3-2" style="text-align: center;" @click="goNotice(2)">通知
					</el-menu-item> -->
				<!-- <el-menu-item index="2-3" style="text-align: center;" @click="goNotice(3)">私信
					</el-menu-item> -->
				<!-- </el-submenu> -->

				<el-submenu index="4">
					<template slot="title">
						<!-- <img src="../assets/img/face.jpg" alt="" width="30" style="border-radius: 50%;"> -->
						<span style="color: #fff;">{{ user_name != null ? user_name : '业主' }},您好</span>
					</template>
					<el-menu-item index="2-1" style="text-align: center;" @click="personalInfor">个人信息</el-menu-item>
					<el-menu-item index="2-1" style="text-align: center;" @click="setPwd">修改密码</el-menu-item>
					<el-menu-item index="2-2" style="text-align: center;" @click="close">退出登录</el-menu-item>
				</el-submenu>
			</el-menu>

		</div>


	</div>
</template>

<script>
import notice from "./messageNotice.vue";
import Screenfull from "@/components/Screenfull";
export default {
  name: "navcon.vue",
  props: ["sumMessage", "baoxiuMessage", "jiazhengMessage"],
  data() {
    return {
      title: "",
      activeName: "first",
      isShow: false, //消息小图标
      icon: false,
      image_src: "",
      user_name: sessionStorage.name,
      user_id: "",
      userName: "",
      //鼠标移入头像
      photolist: false,
      messagelist: false,
      messageInfoList: [], //个人消息列表
      roleId: localStorage.roleId,
    };
  },
  components: {
    notice,
    Screenfull,
  },
  mounted() {
    this.userName = sessionStorage.getItem("name");
  },
  computed: {
    showUnReadMessageInfo() {
      //只展示未读的消息
      return this.messageInfoList.filter((item) => {
        return item.status == 0;
        // return true;
      });
    },
  },
  methods: {
    openPDF() {
      window.open(
        "https://www.jsitc.net.cn//RoomManage/preview/2023-04-28/%E4%B8%9A%E4%B8%BB%E7%AB%AF%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf"
      );
    },
    //
    toJZFW() {
      this.$router.push("/index/apartment/jiazhen");
    },
    toBXGL() {
      this.$router.push("/index/apartment/repair");
    },
    // 去公告和通知页面
    toAnnounceAndNotice() {
      this.$router.push("/index/console/announceAndNotice");
    },

    gotoPre() {
      return;
      this.$router.push("/index/pre");
    },
    isClose() {
      this.isShow = false;
    },

    goNotice(val) {
      this.title = val;
      this.isShow = true;
    },
    // 完善个人信息
    personalInfor() {
      this.$router.push("/personalInfor");
    },
    // 判断是否已完善个人信息
    perfectInfor() {
      this.$http.get("/api/ownerManage/perfectInformation").then((res) => {
        console.log(res);
        if (!res.data.data) {
          this.$confirm("请点击右上方完善个人信息", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        }
      });
    },
    // 修改密码
    setPwd() {
      // this.perfectInfor();
      this.$router.push("/setPwd");
    },
    changeIcon() {
      this.icon = !this.icon;
      this.$emit("left", this.icon);
    },
    // 个人信息设置页
    personal() {
      this.$router.push({
        path: "/personal",
      });
    },
    // 退出
    close() {
      this.$confirm("确定退出系统?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$router.push("/")
          // this.$message.success("退出成功");
          // location.reload()
          // return;
          this.$http.delete("/api/auth/logout").then((res) => {
            //this.$store.commit('$_removeStorage') // 清除登录信息
            sessionStorage.clear();
            localStorage.clear();
            this.$router.push({
              name: "/login",
            });
            this.$message({
              type: "success",
              message: "退出成功!",
            });
            setTimeout(() => {
              location.reload();
            }, 0);
          });
          // this.$store.dispatch('FedLogOut');
        })
        .catch(() => {
          console.log("22");
          this.$message({
            type: "info",
            message: "已取消退出!",
          });
        });
    },
    viewAllInfo() {
      //查看全部信息
      this.$router.push({
        name: "infors",
      });
    },
  },
};
</script>

<style scoped>
.el-icon-question,
.el-icon-circle-plus-outline,
.el-icon-bell {
  font-size: 20px;
  color: #ffffff;
  background-color: #303644;
  cursor: pointer;
  margin: 0 10px;
}

>>> .el-menu--horizontal > .el-menu-item.is-active {
  /* background-color: rgba(0, 0, 0, 0); */
  border-bottom: 0px solid transparent;
}

>>> .el-menu.el-menu--horizontal {
  border: none;
}

@media screen and (max-width: 780px) {
  .sub,
  .why,
  .add,
  .message {
    display: none;
  }
}

.qq {
  color: #b1c0ca;
  font-size: 14px;
}

.isThis {
  background-color: red;
}

.icon {
  /* font-size: 26px;
		padding: 0 15px 0 20px;
		color: rgba(255, 255, 255, 0.6);
		height: 100%;
		line-height: 45px; */
  margin: 0 19px;
}

.icon:hover {
  color: rgba(255, 255, 255, 0.8);
}

.item {
  position: absolute;
  background-color: red;
  color: #fff;
  font-size: 10px;
  border-radius: 10px;
  left: 30px;
  top: 5px;
  padding: 0 4px;
  cursor: pointer;
  transform: scale(0.9);
}

.left {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 45px;
}

.right {
  position: relative;
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  margin-left: 12px;
  white-space: nowrap;
}

.logo {
  display: flex;
  justify-content: center;
}

.logo > img {
  width: 35px;
  height: 35px;
  box-sizing: border-box;
}

.navcon {
  /* background-color: #303644; */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding-right: 10px;
  background-image: url("../assets/icon/bg_top.jpg");
  background-repeat: no-repeat;
}

.el-menu-demo {
  background-color: transparent;
}

>>> .el-menu--horizontal > .el-submenu .is-active,
>>> .el-submenu__title {
  border: 0px solid transparent;
}

>>> .el-submenu__title {
  background-color: transparent !important;
}

.sumMessage {
  position: absolute;
  right: 40px;
  top: 15px;
  display: inline-block;
  background-color: red;
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  color: white;
  font-size: 13px;
}

>>> .el-menu-item:hover {
  background-color: transparent !important;
}

>>> .is-active {
  background-color: transparent !important;
  opacity: 0.8;
}
</style>
